import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store';
import Routing from './config/Routing';
import { ToastContainer } from 'react-toastify';

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Routing />
                <ToastContainer />
            </PersistGate>
        </Provider>
    );
}

export default App;
